import { render, staticRenderFns } from "./DisplayConfiguration.vue?vue&type=template&id=03c64ac5&scoped=true&"
import script from "./DisplayConfiguration.vue?vue&type=script&lang=ts&"
export * from "./DisplayConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c64ac5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDivider,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c64ac5')) {
      api.createRecord('03c64ac5', component.options)
    } else {
      api.reload('03c64ac5', component.options)
    }
    module.hot.accept("./DisplayConfiguration.vue?vue&type=template&id=03c64ac5&scoped=true&", function () {
      api.rerender('03c64ac5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/DisplayConfiguration.vue"
export default component.exports